import React, { Component, Fragment } from 'react';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';
import { Link } from "react-router-dom";

class Policy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      branchType: "",
      taxType: ""
    };
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    console.log(params);
    this.setState({ branchType: params.branchType, taxType: params.taxType });
  }

  _renderPolicyArea() {
    if(this.state.branchType === "tsc") {
      return (
        <div className="termContent">
          <ul className="defaultList">
            <li><p>1. 센터 내 음주 및 흡연은 금합니다.</p></li>
            <li>
              <p className="important">
                2. 개인좌석 내부로 학습환경에 방해되는 <span>비닐류 반입, 마우스 사용 및 타이핑은 금합니다.</span>
              </p>
            </li>
            <li><p>3. 휴대전화는 요청 시 인포데스크에서 보관해 드립니다.</p></li>
            <li><p>4. 식사룸 외에서는 정숙해 주시고, 간단한 대화는 소셜스페이스를 이용해 주세요.</p></li>
            <li>
              <p className="important">
              5. <span>정해진 좌석 외 임의 자리 이동은 불가합니다.</span>
              </p>
            </li>
            <li><p>6. 여러가지 소음으로 인해 타인에게 피해를 주지 않도록 주의해 주세요.</p></li>
            <li>
              <p className="important">
                7. 물품을 분실하지 않도록 귀중품은 사물함 또는 카운터에 보관하시기 바랍니다.
                <br />
                <span>개인물품 분실시 책임지지 않습니다. (CCTV 작동 중)</span>
              </p>
            </li>
            <li><p>8. 센터 내 기물 파손, 사물함 열쇠 분실 시 보상규정에 의거 비용이 청구됩니다.</p></li>
            <li><p>9. 대여 노트북/태블릿은 학습 목적으로만 이용 가능하며, 개인 인터넷 활용 및 게임은 절대 금합니다.</p></li>
            <li><p>10. 그룹스터디룸, 셀프티칭룸은 반드시 예약 후에 이용 가능합니다.</p></li>
            {this._renderCommonArea(10)}
            {this._renderRefundArea(17)}
          </ul>
        </div>
      )
    } else if(this.state.branchType === "tsl") {
      return (
        <div className="termContent">
          <ul className="defaultList">
            <li><p>1. 센터 내 음주 및 흡연은 금합니다.</p></li>
            <li>
              <p className="important">
                2. 개인좌석 내부로 학습환경에 방해되는 <span>비닐류 반입, 마우스 사용 및 타이핑은 금합니다.</span>
              </p>
            </li>
            <li>
              <p className="important">
              3. <span>정해진 좌석 외 임의 자리 이동은 불가합니다.</span>
              </p>
            </li>
            <li><p>4. 여러가지 소음으로 인해 타인에게 피해를 주지 않도록 주의해 주세요.</p></li>
            <li>
              <p className="important">
                5. 귀중품 분실에 주의하시기 바라며, <span>개인물품 분실 시 책임지지 않습니다. (CCTV 작동 중)</span>
              </p>
            <li><p>6. 센터 내 기물 파손, 사물함 열쇠 분실 시 보상규정에 의거 비용이 청구됩니다.</p></li></li>
            {this._renderCommonArea(6)}
            {this._renderRefundArea(13)}
          </ul>
        </div>
      )
    }
  }

  _renderCommonArea(lastNum) {
    return (
      <Fragment>
            <li><p>{++lastNum}. 퇴실 시 짐을 7일이내 수거하지 않으실 경우 자체적으로 처분하게 되고, 그에 대한 책임을 지지 않습니다.</p></li>
            <li>
              <p className="important">
                {++lastNum}. <span>당일 3회 경고 시 3 OUT 제도에 의해 해당일 퇴실조치 됩니다.</span>
              </p>
            </li>
            <Fragment>
              <li>
                <p className="important">
                  {++lastNum}. <span>매월 하루는 휴무</span>일입니다.(상황에 따라 변경될 수 있으며, 변경 시 사전 공지됨)
                </p>
              </li>
            </Fragment>
            <li><p>{++lastNum}. 출입은 지문 등록을 통해 회원 본인만 가능하며, 등록된 지문 정보는 이용 종료 후, 1주일내 삭제됩니다.</p></li>
            <li><p>{++lastNum}. 열람실 내 「보안관리/시설관리/범죄 및 화제 예방」을 위해, 24시간 연속 CCTV 촬영됩니다.</p></li>
            <li><p>{++lastNum}. 상기 수집한 내용은 개인정보보호법에 의거하여 ‘회원관리’ 이외의 용도로 이용되지 않습니다.</p></li>
            <li><p>{++lastNum}. 본인만 이용이 가능하며, ‘타인 양도’는 불가합니다.</p></li>
      </Fragment>
    )
  }

  _renderRefundArea(lastNum) {
    return (
      <li className="over">
        <p className="important">
          {++lastNum}. <span>환불 시, 등록 요금제에 따라 아래 법률에 의거하여 해당 금액이 반환됩니다.</span>
        </p>
        <ul className="depth two opa">
          {
            this.state.taxType !== "tax" ?
            <li>
              <p>가.	학원  설립.운영 및 과외교습에 관한 법률</p>
              <ul className="depth three">
                <li><p>1) 학습장소 사용 전인 경우, 이미 납부한 교습비등의 전액</p></li>
                <li><p>2) 사용기간이 1개월 이내인 경우, 학습장소 사용 시작일로부터 사용 포기한 날의 전날까지 규정 적용 환불</p></li>
                <li><p>3) 사용기간이 1개월 이상인 경우, 반환사유가 발생한 해당 월의 교습비에 나머지 월의 교습비 등의 전액을 합산한 금액</p></li>
              </ul>
            </li> : ""
          }
          <li>
            <p>{this.state.taxType === "tax" ? "가." : "나."}	소비자보호법에 관한 법률</p>
            <ul className="depth three">
              <li><p>1) 결제금액의 10%에 해당하는 위약금과 이용기간(또는 시간)만큼 공제 후 환불됩니다.</p></li>
              <li><p>2) 회원의 개인사유로 중도 해지 후 환불을 요청할 경우, 할인 적용 요금은 정상가 기준으로 공제 후 환불됩니다.</p></li>
              <li><p>3) 이용기간 만료 후에는 환불이 불가합니다.</p></li>
            </ul>
          </li>
        </ul>
      </li>
    )
  }

  render() {
    return (
      <div className="member-policy card-policy popup">

        <div className="rule">
          <div className="rule_list">
            <div className="rule_item">
              <br/>
              <h3 style={{textAlign: "center"}}>&lt;이용수칙&gt;</h3>
              <br/>

              { this._renderPolicyArea() }
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Policy;